<template>
	<div>
		<Header></Header>
		<Login></Login>
		<div class="devSupportWrap">
			<iframe class="iframe" frameborder="0" width="1280px" src="http://106.14.64.159:8080/web/#/61?page_id=2024"></iframe>
		</div>
	</div>
</template>

<script>
import Header from "@/components/Header.vue";
import Login from "@/components/Login.vue";
export default {
		components: {
			Header,
			Login
		},
    data(){
			return {

			}
    },
    methods:{

    },
    created(){

    }
}
</script>

<style lang="less">
.devSupportWrap {
	position: relative;
	width: 100%;
	height: calc(100vh - 57px);
	padding-top: 20px;
	background: rgb(250, 250, 250);
	box-sizing: border-box;
	overflow: hidden;

	.iframe {
		width: 1280px;
		height: 100%;
		margin-left: 50%;
	  transform: translateX(-50%);
		border: none;
		overflow: hidden;
	}
}
</style>


